<div class="hub">
  <button type="button" class="btn-close hub-close" aria-label="Fechar" (click)="modal.dismiss()"></button>

  <!-- Topo: progresso + próximo passo -->
  <div class="hub-top">
    <div class="hub-progress" [attr.aria-label]="doneCount() + ' de ' + tours.length + ' concluídos'">
      <svg viewBox="0 0 36 36" aria-hidden="true">
        <circle class="hub-ring-bg" cx="18" cy="18" r="15.5"></circle>
        <circle class="hub-ring" cx="18" cy="18" r="15.5"
          [attr.stroke-dasharray]="(doneCount() / tours.length * 97.4) + ' 97.4'"></circle>
      </svg>
      <span class="hub-progress-num">{{ doneCount() }}<small>/{{ tours.length }}</small></span>
    </div>
    <div class="hub-top-text">
      <h5 class="mb-0">Aprenda o MarketConnector</h5>
      <span class="text-muted small">Conheça cada módulo com tutoriais rápidos e os dados da sua empresa.</span>
    </div>
  </div>

  <!-- Trilha: o caminho da operação, com o que já foi feito e o próximo -->
  @if (trail.length > 1) {
    <div class="hub-trail" role="list" aria-label="Trilha recomendada">
      @for (step of trail; track step.id; let last = $last) {
        <button type="button" class="hub-trail-step" role="listitem"
          [class.is-done]="tour.isCompleted(step.id)" [class.is-next]="recommended?.id === step.id"
          (click)="start(step)" [attr.aria-label]="step.label + (tour.isCompleted(step.id) ? ' (concluído)' : '')">
          <span class="hub-trail-dot">
            <i class="ti" [ngClass]="tour.isCompleted(step.id) ? 'ti-check' : step.icon"></i>
          </span>
          <span class="hub-trail-label">{{ step.label }}</span>
        </button>
        @if (!last) {
          <span class="hub-trail-line" [class.is-done]="tour.isCompleted(step.id)" aria-hidden="true"></span>
        }
      }
    </div>
  }

  @if (recommended; as next) {
    <button type="button" class="hub-cta" (click)="start(next)">
      <span class="hub-cta-ic"><i class="ti ti-player-play-filled"></i></span>
      <span class="hub-cta-text">
        <span class="hub-cta-eyebrow">{{ doneCount() === 0 ? 'Comece por aqui' : 'Próximo da trilha' }}</span>
        <strong>{{ next.label }}</strong> <span class="text-muted">· {{ next.summary }}</span>
      </span>
      <span class="hub-cta-time">{{ tour.durationLabel(next) }}</span>
    </button>
  } @else {
    <div class="hub-cta hub-cta--done"><span class="hub-cta-ic"><i class="ti ti-trophy"></i></span>
      <span class="hub-cta-text"><strong>Trilha concluída.</strong> <span class="text-muted">Você pode rever qualquer tutorial.</span></span>
    </div>
  }

  <!-- Todos os tutoriais: lista compacta, uma linha por tutorial -->
  <div class="hub-list-head">
    <span>Todos os tutoriais</span>
    <div class="input-group input-group-sm input-group-merge hub-search">
      <span class="input-group-text"><i class="ti ti-search"></i></span>
      <input type="search" class="form-control" placeholder="Buscar tutorial" [ngModel]="search()" (ngModelChange)="search.set($event)" />
    </div>
  </div>

  <div class="hub-list">
    @for (group of groups(); track group.id) {
      <div class="hub-group-title">{{ group.label }}</div>
      @for (item of group.tours; track item.id) {
        <button type="button" class="hub-row" [class.is-done]="tour.isCompleted(item.id)" (click)="start(item)">
          <span class="hub-row-ic"><i [ngClass]="item.icon"></i></span>
          <span class="hub-row-text">
            <span class="hub-row-label">{{ item.label }}</span>
            <span class="hub-row-summary">{{ item.summary }}</span>
          </span>
          <span class="hub-row-meta">
            @if (tour.isCompleted(item.id)) {
              <i class="ti ti-circle-check-filled text-success" aria-label="Concluído"></i>
            } @else {
              {{ tour.durationLabel(item) }}
            }
          </span>
        </button>
      }
    } @empty {
      <div class="text-center text-muted small py-4">Nenhum tutorial encontrado para "{{ search() }}".</div>
    }
  </div>
</div>
